// removed by extract-text-webpack-plugin
module.exports = {"page-wrapper":"page-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/MainContent/Index.scss
// module id = 911
// module chunks = 0